import { useEffect, useRef, useState } from 'react';
import { withErrorBoundary } from 'react-error-boundary';

import { cn } from 'lib/helpers/utility';

import { POSITION_CLASSES } from './lib/getPosition';

/**
 * @param {import('./lib/propTypes').LazyImageProps} props
 */

const LazyImage = (props) => {
  const {
    src,
    alt,
    width,
    height,
    position = 'center',
    className,
    imgClassName,
    blurEffect = true,
    isRoundedSmooth = false
  } = props;

  const wrapperRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' }
    );

    if (wrapperRef.current) {
      observer.observe(wrapperRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!inView) return;
    const img = new Image();
    img.src = src;
    img.onload = () => setLoaded(true);
  }, [inView, src]);

  return (
    <div
      ref={wrapperRef}
      className={cn('relative overflow-hidden', className)}
      style={{
        width,
        height
      }}>
      {inView && (
        <img
          src={src}
          alt={alt}
          width="100%"
          height="100%"
          className={cn(
            'block h-full w-full object-cover',
            isRoundedSmooth && 'rounded-smooth',
            blurEffect && !loaded ? 'blur-[20px] filter' : 'filter-none',
            loaded ? 'opacity-100' : 'opacity-60',
            'transition-all duration-500 ease-in-out',
            POSITION_CLASSES[position],
            imgClassName
          )}
        />
      )}
    </div>
  );
};

export default withErrorBoundary(LazyImage);
